/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./alt.button.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../button/button.component.ngfactory";
import * as i3 from "../button/button.component";
import * as i4 from "./alt.button.component";
var styles_AltButtonComponent = [i0.styles];
var RenderType_AltButtonComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_AltButtonComponent, data: {} });
export { RenderType_AltButtonComponent as RenderType_AltButtonComponent };
export function View_AltButtonComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 2, "ig-button", [["class", "ig-alt-btn"]], null, [[null, "trigger"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("trigger" === en)) {
        var pd_0 = (_co.btnClick() !== false);
        ad = (pd_0 && ad);
    } return ad; }, i2.View_ButtonComponent_0, i2.RenderType_ButtonComponent)), i1.ɵdid(1, 49152, null, 0, i3.ButtonComponent, [], null, { trigger: "trigger" }), (_l()(), i1.ɵted(-1, 0, ["search"])), (_l()(), i1.ɵted(-1, null, ["\n"])), (_l()(), i1.ɵeld(4, 0, null, null, 0, "span", [["class", "ig-alt-cover"]], null, [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.btnCancel($event) !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), (_l()(), i1.ɵted(-1, null, ["\n\n\n"]))], null, null); }
export function View_AltButtonComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ig-alt-button", [], null, null, null, View_AltButtonComponent_0, RenderType_AltButtonComponent)), i1.ɵdid(1, 49152, null, 0, i4.AltButtonComponent, [], null, null)], null, null); }
var AltButtonComponentNgFactory = i1.ɵccf("ig-alt-button", i4.AltButtonComponent, View_AltButtonComponent_Host_0, {}, { trigger: "trigger", cancel: "cancel" }, []);
export { AltButtonComponentNgFactory as AltButtonComponentNgFactory };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/alt.button/alt.button.component.ngfactory.js.pre-build-optimizer.js